/* istanbul ignore file */
import React from 'react';
import { getExperiments } from '@noths/polaris-client-experiments';
import { setLocaleCookies } from '@noths/polaris-client-localisation';
import { BaseApp, BaseAppProps } from '@noths/polaris-client-next-components';
import { SkipLinks } from '@noths/polaris-client-site-chrome-ui';
import { AppContextPlusCookies } from '@noths/polaris-dev-ts-types';
import NextApp, { AppInitialProps, AppProps } from 'next/app';
import getConfig from 'next/config';
import Head from 'next/head';

import { APP_STORE_ID } from 'src/constants/pageAttributes';
import { fetchGlobalContent } from 'src/services/contentstack';
import { SKIP_CONTENT_TARGET_ID } from '../constants/elementIds';

const config = getConfig();
const AppComponent = BaseApp(config);

const App = (props: AppProps & BaseAppProps) => (
  <>
    <Head>
      <meta name="apple-itunes-app" content={`app-id=${APP_STORE_ID}`} />
    </Head>
    <SkipLinks links={[{ content: 'Skip to content', sectionId: SKIP_CONTENT_TARGET_ID }]} />
    <AppComponent {...props} />
  </>
);

App.getInitialProps = async (
  appContext: AppContextPlusCookies,
): Promise<AppInitialProps & BaseAppProps> => {
  const {
    router,
    ctx: { req, res },
  } = appContext;

  if (req && res) {
    setLocaleCookies({ req, res });
  }

  const experiments = (req && getExperiments(req)) ?? '';
  const appProps = await NextApp.getInitialProps(appContext);

  if (router.route === '/404') {
    const [navData] = await fetchGlobalContent({ experiments });

    return {
      ...appProps,
      navData,
      experiments,
    };
  }

  return { ...appProps, experiments };
};

export default App;
